import { firestoreRef } from "api";
import { getAppTime, getPaper, getQuestionsForPaper } from "./firebase";

export function getPaperAndQuestions(examKey, paperKey) {
  return async dispatch => {
    try {
      let paper = await getPaper(paperKey);
      dispatch({ type: "GET_PAPER", payload: paper });
      let questions = await getQuestionsForPaper(paper.paperKey);
      dispatch({ type: "GET_PAPER_QUESTIONS", payload: questions });
    } catch (e) {
      console.log(e);
    }
  };
}

export function listenQuiz(quiz) {
  return dispatch => {
    firestoreRef
      .collection("live_quiz")
      .doc(quiz)
      .onSnapshot(doc => {
        dispatch({ type: "GET_USER_QUIZ", payload: doc.data() });
      });
  };
}

export function submitExamAction(quizKey) {
  return async dispatch => {
    firestoreRef
      .collection("live_quiz")
      .doc(quizKey)
      .update({ completed: true });
  };
}

export function startExamAction(endTime) {
  return async dispatch => {
    let serverTime = await getAppTime();
    let remainingTime = parseInt(endTime) - parseInt(serverTime.data);
    dispatch({ type: "EXAM_START" });
    let interval = setInterval(() => {
      remainingTime = remainingTime - 1000;
      if (remainingTime < 0) {
        dispatch({ type: "END_EXAM" });
        submitExamAction();
        clearInterval(interval);
      } else {
        dispatch({ type: "EXAM_TIME", payload: remainingTime });
      }
    }, 1000);
  };
}
